import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import Divider from "@material-ui/core/Divider";
import InboxIcon from "@material-ui/icons/Inbox";
import DraftsIcon from "@material-ui/icons/Drafts";
import { getThemeProps } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function SelectedListItem(props) {
  const classes = useStyles();
  const [selectedIndex, setSelectedIndex] = React.useState();
  const [segments, setSegments] = React.useState(props.segments);

  const handleListItemClick = (event, index, listitem) => {
    let selectedEnvs = props.selectedEnv
    let selectedEnv  = selectedEnvs[props.index]
    selectedEnv['segment'] = listitem     
    selectedEnvs[props.index] = selectedEnv
    setSelectedIndex(index);
    props.setSelectedSegment(listitem)
    props.setSelectedEnv(selectedEnvs)
  };

  const filterSegments = search => {
    setSegments(props.segments.filter(e => e.name.toLowerCase().includes(search.toLowerCase())))
  }

  return (
    <div className={classes.root}>
      <input
        style={{width: '100%'}}
        placeholder="Search segment"
        onKeyUp={event => filterSegments(event.target.value)}
      />
      <List aria-label="secondary mailbox folder">
        <ListItem
          key={0}
          button
          selected={selectedIndex === 0}
          onClick={(event) => handleListItemClick(event, 0, {id: 0, name: 'No segment'})}
        >
          <ListItemIcon>
                    <Radio
                      edge="start"
                      checked={selectedIndex === 0}
                      tabIndex={-1}
                      disableRipple
                    />
                  </ListItemIcon>
          <ListItemText primary={'No segment'} />
        </ListItem>
        {segments &&
          segments.map((listitem, index) => {
            index = index+1
            return (
              <ListItem
                key={listitem.id}
                button
                selected={selectedIndex === index}
                onClick={(event) => handleListItemClick(event, index, listitem)}
              >
                <ListItemIcon>
                    <Radio
                      edge="start"
                      checked={selectedIndex === index}
                      tabIndex={-1}
                      disableRipple
                    />
                  </ListItemIcon>
                <ListItemText primary={listitem.name} />
              </ListItem>
            );
          })}
      </List>
    </div>
  );
}
